import { AspectRatioToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackPositionType, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from '../partnerWeb_Dashboard/types';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { isMobile, showCollateralTab, showEarning, showInviteAndEarnTab, showMFC, showViewCustomerPortfolio } from "../../configs/utils";
import { showAccountDetails, showCGS, showCompletedApplications, showDashboard, showDemoVideos, showInterestCalculator, showPendingApplications } from "../../configs/uri-config-utils";
import { getReferredPartnerSideNavTitle } from "../partnerWeb_Dashboard/utils";
export const SideBarBuilderDS = async (routeId) => {
    const _user = JSON.parse(await AsyncStorage.getItem(StoreKey.userContext));
    const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
    const referredPartnerTitle = await getReferredPartnerSideNavTitle();
    const DS = {
        sideNav: {
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            type: StackType.column,
            padding: {
                left: SizeTypeTokens.XL,
                top: SizeTypeTokens.Size32,
                right: SizeTypeTokens.SM
            },
            widgetItems: [
                showDashboard(_user) ? { id: 'dashboardStack', type: WIDGET.STACK } : {},
                showPendingApplications(_user) ? { id: 'leadsStack', type: WIDGET.STACK } : {},
                showCGS(_user) ? { id: 'partnerGainStatementStack', type: WIDGET.STACK } : {},
                showCompletedApplications(_user) ? { id: 'activeCustomerStack', type: WIDGET.STACK } : {},
                showInterestCalculator(_user) ? { id: 'interestCalculatorCustomerStack', type: WIDGET.STACK } : {},
                showInviteAndEarnTab(partnerAccountType, _user) ? { id: 'referredPartnerStack', type: WIDGET.STACK } : {},
                showEarning(partnerAccountType, _user) ? { id: 'EarningPartnerStack', type: WIDGET.STACK } : {},
                showMFC(partnerAccountType, _user) ? { id: 'checkLimitPartnerStack', type: WIDGET.STACK } : {},
                !isMobile() && showViewCustomerPortfolio(partnerAccountType, _user) ? { id: 'checkCustomerPortfolioStack', type: WIDGET.STACK } : {},
                showCollateralTab(partnerAccountType, _user) ? { id: 'collateralStack', type: WIDGET.STACK } : {},
                showDemoVideos(_user) ? { id: 'demoVideosStack', type: WIDGET.STACK } : {},
                showAccountDetails(_user) ? { id: 'myAccountStack', type: WIDGET.STACK } : {},
                showAccountDetails(_user) ? { id: 'spaceSB5', type: WIDGET.SPACE } : {},
            ],
        },
        interestCalculatorCustomerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            setStackClickable: true,
            minWidth: 210,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'interestCalculatorCustomerStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'interestCalculatorCustomerStackText', type: WIDGET.TEXT },
                { id: 'spaceSB61', type: WIDGET.SPACE },
                { id: 'interestCalculatorCustomerImageStack', type: WIDGET.STACK },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'interestCalculatorPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.INTEREST_CALCULATOR,
                },
            },
        },
        interestCalculatorCustomerImageStack: {
            type: StackType.row,
            position: StackPositionType.relative,
            positionConfig: {
                bottom: SizeTypeTokens.SM
            },
            widgetItems: [
                { id: 'interestCalculatorCustomerImage', type: WIDGET.IMAGE },
            ]
        },
        interestCalculatorCustomerImage: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/interestCalculatorNewImage.svg',
            width: 32,
            height: 20
        },
        interestCalculatorCustomerStackIcon: {
            name: IconTokens.INTEREST_CALCULATOR,
            color: routeId === ROUTE.INTEREST_CALCULATOR ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        interestCalculatorCustomerStackText: {
            label: 'Interest calculator',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.INTEREST_CALCULATOR ? '600' : '400',
            lineHeight: 20,
            numberOfLines: 2,
            color: routeId === ROUTE.INTEREST_CALCULATOR
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        checkCustomerPortfolioStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            setStackClickable: true,
            minWidth: 210,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'checkCustomerPortfolioStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'checkCustomerPortfolioStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO,
                },
            },
        },
        checkCustomerPortfolioStackIcon: {
            name: IconTokens.Earning,
            color: routeId === ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        checkCustomerPortfolioStackText: {
            label: 'View customer portfolio',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO ? '600' : '400',
            lineHeight: 20,
            numberOfLines: 2,
            color: routeId === ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        EarningPartnerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'earningStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'earningStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.EARNING,
                },
            },
        },
        partnerGainStatementStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'partnerGainStatementIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'capitalGainStatementText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_CAPITAL_GAIN,
                },
            },
        },
        earningStackIcon: {
            name: IconTokens.Earning,
            color: routeId === ROUTE.EARNING ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        partnerGainStatementIcon: {
            name: IconTokens.CAPITAL_GAIN_STATEMENT,
            color: routeId === ROUTE.PARTNER_CAPITAL_GAIN ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        earningStackText: {
            label: 'Earnings',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.EARNING ? '600' : '400',
            lineHeight: 20,
            numberOfLines: 2,
            color: routeId === ROUTE.EARNING
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        capitalGainStatementText: {
            label: 'Capital gain statement',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PARTNER_CAPITAL_GAIN ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PARTNER_CAPITAL_GAIN
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        checkLimitPartnerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'checkLimitStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'checkLimitStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_CHECK_LIMIT,
                },
            },
        },
        checkLimitStackText: {
            label: 'Eligibility check in 15s',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PARTNER_CHECK_LIMIT ? '600' : '400',
            lineHeight: 20,
            numberOfLines: 2,
            color: routeId === ROUTE.PARTNER_CHECK_LIMIT
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        checkLimitStackIcon: {
            size: IconSizeTokens.XXL,
            name: routeId === ROUTE.PARTNER_CHECK_LIMIT ? IconTokens.Check_Limit_1 : IconTokens.Check_Limit_Grey,
        },
        referredPartnerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'referredPartnerStackIcon', type: WIDGET.LOTTIE },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'referredPartnerStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_REFERRED_PARTNER,
                },
            },
        },
        collateralStack: {
            type: StackType.row,
            minWidth: 210,
            width: StackWidth.MATCH_PARENT,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'collateralStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'collateralStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'collateralPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.COLLATERAL,
                },
            },
        },
        demoVideosStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            setStackClickable: true,
            minWidth: 210,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'demoVideoIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'demoVideoText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'demoVideoPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.DEMO_VIDEOS,
                },
            },
        },
        dashboardStackText: {
            label: 'Dashboard',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: '400',
            lineHeight: 20,
            color: routeId === ROUTE.PARTNER_DASHBOARD_V2
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        dashboardStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'dashBoardStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB4', type: WIDGET.SPACE },
                { id: 'dashboardStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'dashboardLegacy',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_DASHBOARD_V2,
                },
            },
        },
        myAccountStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'myAccountIcon', type: WIDGET.ICON },
                { id: 'spaceSB4', type: WIDGET.SPACE },
                { id: 'myAccountText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'dashboardLegacy',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.MY_ACCOUNT,
                },
            },
        },
        referredPartnerStackText: {
            label: referredPartnerTitle
                ? referredPartnerTitle
                : 'Win a Trip to Bali',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PARTNER_REFERRED_PARTNER ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PARTNER_REFERRED_PARTNER
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        collateralStackText: {
            label: 'Collaterals',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.COLLATERAL ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.COLLATERAL
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        myAccountText: {
            label: 'Account details',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.MY_ACCOUNT ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.MY_ACCOUNT
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        demoVideoText: {
            label: 'Demo videos',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.DEMO_VIDEOS ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.DEMO_VIDEOS
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        dashBoardStackIcon: {
            name: IconTokens.Grid_View,
            color: routeId === ROUTE.PARTNER_DASHBOARD_V2 ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        myAccountIcon: {
            name: IconTokens.AccountDetails,
            color: routeId === ROUTE.MY_ACCOUNT ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        referredPartnerStackIcon: {
            uri: LottieTokens.Gift,
            size: LottieSizeTokens.Size20,
            autoplay: true,
            aspectRatio: AspectRatioToken.A1_1
        },
        collateralStackIcon: {
            name: IconTokens.Collateral,
            color: routeId === ROUTE.COLLATERAL ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        demoVideoIcon: {
            name: IconTokens.DemoVideo,
            color: routeId === ROUTE.DEMO_VIDEOS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        leadsStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'leadsStackIcon', type: WIDGET.ICON },
                { id: 'leadsStackSpace0', type: WIDGET.SPACE },
                { id: 'leadsStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'leadPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_LEAD,
                },
            },
        },
        activeCustomerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            minWidth: 210,
            setStackClickable: true,
            padding: {
                top: SizeTypeTokens.LG,
                bottom: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'activeCustomerIcon', type: WIDGET.ICON },
                { id: 'activeCustomerSpace0', type: WIDGET.SPACE },
                { id: 'activeCustomerText', type: WIDGET.TEXT }
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'activeCustomerPage',
                    widgetId: 'renderWidgetGroup',
                    route: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                },
            },
        },
        leadsStackIcon: {
            name: IconTokens.Lead2,
            color: routeId === ROUTE.PARTNER_LEAD ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        leadsStackText: {
            label: 'Pending applications',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PARTNER_LEAD ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PARTNER_LEAD
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        activeCustomerIcon: {
            name: IconTokens.Leads,
            size: IconSizeTokens.LG,
            color: routeId === ROUTE.PARTNER_ACTIVE_CUSTOMER ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        activeCustomerText: {
            label: 'Completed applications',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PARTNER_ACTIVE_CUSTOMER ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PARTNER_ACTIVE_CUSTOMER
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        spaceSB0: {
            size: SizeTypeTokens.XXXL,
        },
        spaceSB3: {
            size: SizeTypeTokens.XXXL,
        },
        spaceSB4: {
            size: SizeTypeTokens.XL,
        },
        spaceSB5: {
            size: SizeTypeTokens.XXXL,
        },
        spaceSB6: {
            size: SizeTypeTokens.XL,
        },
        spaceSB61: {
            size: SizeTypeTokens.SM,
        },
        leadsStackSpace0: {
            size: SizeTypeTokens.XL,
        },
        activeCustomerSpace0: {
            size: SizeTypeTokens.XL,
        },
    };
    return DS;
};
